<template>
  <div class="deal_col flex-between-left">
    <!-- <img
      src="https://img.zcool.cn/community/01eafb5d2b3736a8012148379339e3.jpg@1280w_1l_2o_100sh.jpg"
    /> -->
    <div>
      <h3 class="line title">
        {{ cData.name }}
      </h3>
      <div class="flex-between flex-wrap cont">
        <div class="flex-left-center">项目编号：{{ cData.code }}</div>
        <div class="flex-left-center">
          成交价格(万元)：
          <span v-if="cData.dealPrice">{{ priceCurrencyPrefix(cData.foreignType || cData.floorPriceUnit) }} {{ cData.dealPrice }}</span>
          <span v-else>面议</span>
        </div>
      </div>
      <div class="flex-left-center cont">
        成交时间：{{ cData.createTime | dateSy('YYYY-MM-DD') }}
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, priceCurrencyPrefix } from "../api/util";
export default {
  methods: {
    priceCurrencyPrefix,
  },
  props: {
    cData: {
      type: Object,
      default: {},
    },
  },
  //过滤器
  filters: {
    formatDate(val) {
      return formatDate(val);
    },
  },
};
</script>

<style lang="scss">
.deal_col {
  border: #cccccc solid 1px;
  border-radius: 5px;
  padding: 16px;
  cursor: pointer;

  &>img {
    width: 16%;
  }

  &>div {
    width: 80%;
    font-size: 14px;

    h3 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #333333;
    }

    .cont {
      color: #777777;

      span {
        font-size: 18px;
        color: red;
      }

      &>div {
        flex: 1;
      }
    }
  }
}
</style>
